import type { JobDetail } from './job-by-id-query';

/**
 * EU-569 — vagas Encerradas ou Canceladas abrem TODAS as seções de edição em
 * modo SOMENTE VISUALIZAÇÃO: campos/cards desabilitados, tooltip "Edição
 * bloqueada", "Salvar alterações" desabilitado nas seções de etapa única,
 * "Avançar" só navega nas multi-etapa (Formação → Cursos) e o kanban de
 * Etapas de seleção fica bloqueado. "Voltar" permanece habilitado.
 *
 * O status vem cru do BFF (`job.status`: 'ativa' | 'ativa-privada' |
 * 'rascunho' | 'encerrada' | 'cancelada') — mesmo vocabulário do
 * `JobStatus` do JobManagementPage.
 */
export function isJobReadOnly(status: string | null | undefined): boolean {
  return status === 'encerrada' || status === 'cancelada';
}

/** Conveniência para os containers: `undefined` (carregando) nunca bloqueia. */
export function isJobDetailReadOnly(job: Pick<JobDetail, 'status'> | undefined): boolean {
  return isJobReadOnly(job?.status as string | undefined);
}
